export var MarkAsReadModes;
(function (MarkAsReadModes) {
    MarkAsReadModes["AUTOMATIC"] = "AUTOMATIC";
    MarkAsReadModes["MANUAL"] = "MANUAL";
    MarkAsReadModes["MANUAL_AND_CLICK"] = "MANUAL_AND_CLICK";
})(MarkAsReadModes || (MarkAsReadModes = {}));
export var PopupPosition;
(function (PopupPosition) {
    PopupPosition["TopLeft"] = "topLeft";
    PopupPosition["TopRight"] = "topRight";
    PopupPosition["LeftTop"] = "leftTop";
    PopupPosition["LeftBottom"] = "leftBottom";
    PopupPosition["BottomLeft"] = "bottomLeft";
    PopupPosition["BottomRight"] = "bottomRight";
    PopupPosition["RightTop"] = "rightTop";
    PopupPosition["RightBottom"] = "rightBottom";
})(PopupPosition || (PopupPosition = {}));
export var PushProviders;
(function (PushProviders) {
    PushProviders["FCM"] = "FCM";
    PushProviders["APN"] = "APN";
})(PushProviders || (PushProviders = {}));
